import { render, staticRenderFns } from "./faqMail.vue?vue&type=template&id=37e8d997&"
import script from "./faqMail.vue?vue&type=script&lang=js&"
export * from "./faqMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports